// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__17X7u","dragIcon":"Choice_dragIcon__1Qa_R","left":"Choice_left__2IK-B","input":"Choice_input__1FGxx"};